'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIButton from 'UIComponents/button/UIButton';
import { LORAX, EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import getFreemiumViralLink from 'MeetingsLib/components/freemium/getFreemiumViralLink';
import { BOOKING_VIRAL_HUBS_CTA } from 'MeetingsLib/constants/paths';
var FreemiumBookingUpgradeLink = createReactClass({
  displayName: "FreemiumBookingUpgradeLink",
  goToMeetingsPage: function goToMeetingsPage(viralLink) {
    track('meetingsLibClickPromoLink', {
      page: 'booking'
    });
    window.open(viralLink, '_blank');
  },
  renderUpgradeLink: function renderUpgradeLink() {
    var _this = this;

    var embedded = this.props.embedded;
    var viralLink = getFreemiumViralLink(BOOKING_VIRAL_HUBS_CTA, this.props.portalId, embedded);
    return /*#__PURE__*/_jsx(UIButton, {
      style: {
        width: 'inherit'
      },
      use: "link",
      onClick: function onClick() {
        _this.goToMeetingsPage(viralLink);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "prebook.freemium.linkText"
      })
    });
  },
  render: function render() {
    var embedded = this.props.embedded;
    var verticalPadding = embedded ? 'p-y-2' : 'p-y-3';
    return /*#__PURE__*/_jsxs("div", {
      className: "text-center date-picker-freemium-cta " + verticalPadding,
      style: {
        color: EERIE
      },
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "sprocket",
        color: LORAX,
        className: "m-right-1"
      }), /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "prebook.freemium.ctaText",
        options: {
          linkText: this.renderUpgradeLink()
        }
      })]
    });
  }
});
export default connect(function (state) {
  return {
    portalId: state.portalId
  };
})(FreemiumBookingUpgradeLink);